import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
    Textarea,
} from '@repo/shadcn';

import { IwForm } from '@components/form';
import { PdfExportIcon } from '@components/icons';
import { HeaderBreadcrumb } from '@components/ui';

import HeadingWrapper from '@/components/ui/heading/heading-wrapper';
import PageHeading from '@/components/ui/heading/page-headeing';
import { Route } from '@/constants';

import { ActionButton } from './action-button.component';
import { AddProduct } from './add-product.component';
import {
    WholesaleOrderRequestDetailsProvider,
    useWholesaleOrderRequestDetailsContext,
} from './context';
import { ProductsTable } from './product-table.component';
import { ConfirmOrderFormSchema } from './schema';

export const WholesaleOrderRequestDetailsComponent = () => {
    const { handleSubmit, handleExportToPdf, data, isLoading } =
        useWholesaleOrderRequestDetailsContext();

    const renderForm = () => {
        if (isLoading) {
            return <p>Loading...</p>;
        }

        return (
            <IwForm
                logErrors
                schema={ConfirmOrderFormSchema}
                onSubmit={handleSubmit}
                initialValues={{
                    paid_amount: 0,
                    items: data?.data?.items,
                }}
            >
                <div className="mb-4 grid grid-cols-1 gap-4 md:grid-cols-3">
                    <div className="md:col-span-2">
                        <RequestSummary />
                        <AddProduct />
                        <ProductsTable />
                    </div>
                    <div>
                        <CustomerInfo />
                        <OrderNotes />
                        <ActionButton />
                    </div>
                </div>
            </IwForm>
        );
    };

    return (
        <Card className="space-y-4 p-4">
            <HeadingWrapper>
                <div className="flex items-center justify-between">
                    <div>
                        <HeaderBreadcrumb
                            items={[
                                {
                                    label: 'Wholesale Requests',
                                    href: Route.WHOLESALE_ORDER_REQUESTS,
                                },
                                {
                                    label: 'Request Details',
                                },
                            ]}
                        />
                        <PageHeading title="Request Details" subTitle="" />
                    </div>
                    <div>
                        <button
                            type={'button'}
                            className={'scale-[1.2]'}
                            onClick={handleExportToPdf}
                        >
                            <PdfExportIcon />
                        </button>{' '}
                    </div>
                </div>
            </HeadingWrapper>
            {renderForm()}
        </Card>
    );
};

const RequestSummary = () => {
    const { data } = useWholesaleOrderRequestDetailsContext();

    return (
        <Card className="mb-4">
            <CardHeader>
                <CardTitle>Request Summary</CardTitle>
            </CardHeader>
            <CardContent className="">
                <p>Request ID: {data?.data?.id}</p>
                {/* <p>Status: {data?.data?.status}</p> */}
                <p>
                    Created At:{' '}
                    {new Date(data?.data?.created_at || '').toLocaleString()}
                </p>

                {data?.data?.notes && (
                    <p className="">
                        <span className="font-bold">Note:</span>{' '}
                        <span
                            className={
                                'block rounded-sm border bg-orange-50 p-2'
                            }
                        >
                            {data?.data?.notes}
                        </span>
                    </p>
                )}
            </CardContent>
        </Card>
    );
};

const CustomerInfo = () => {
    const { data } = useWholesaleOrderRequestDetailsContext();

    return (
        <Card className="mb-4">
            <CardHeader>
                <CardTitle>Customer Information</CardTitle>
            </CardHeader>
            <CardContent className="">
                <p>
                    <span className="font-bold">Name:</span>{' '}
                    {data?.data?.customer?.name}
                </p>
                <p>
                    <span className="font-bold">Phone Number:</span>{' '}
                    {data?.data?.customer?.phone_number}
                </p>
                <p>
                    <span className="font-bold">Email:</span>{' '}
                    {data?.data?.customer?.email}
                </p>
                <p>
                    <span className="font-bold">Address:</span>{' '}
                    {data?.data?.customer?.address}
                </p>
            </CardContent>
        </Card>
    );
};

const OrderNotes = () => {
    return (
        <Card className="mb-4">
            <CardHeader>
                <CardTitle>Order Notes</CardTitle>
            </CardHeader>
            <CardContent className="">
                <Textarea />
            </CardContent>
        </Card>
    );
};

export const WholesaleOrderRequestDetails = () => {
    return (
        <WholesaleOrderRequestDetailsProvider>
            <WholesaleOrderRequestDetailsComponent />
        </WholesaleOrderRequestDetailsProvider>
    );
};
